<template>
    <div class="todo-list__unpaid-banner">
        <span v-html="message"></span>
    </div>
</template>

<script>
export default {
    name: 'UnpaidInvoiceBanner',
    props: {
        // HTML-translated string. The parent (Blade) is responsible for
        // interpolating the invoice link inside the message (e.g. via Laravel
        // `__()` + `:link` placeholder) so the component stays i18n-agnostic.
        message: { type: String, required: true },
    },
};
</script>
